import { useApolloClientHeaders } from '@hooks/useApolloClientHeaders';

export const useIsInternalTraffic = () => {
  const { traffic } = useApolloClientHeaders();

  return traffic === 'internal';
};
